<template>
  <div>
    <DxForm id="formularioUsuario" ref="formInstance" :form-data="model" label-location="top"
      :show-colon-after-label="false" :visible="model != null" validation-group="validacionUsuario">
      <!-- xs: 768, sm: 992, md:1200 -->
      <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

      <!-- Datos del usuario -->
      <DxGroupItem :col-span="6" :col-count="6">
        <DxSimpleItem data-field="Nombre" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('usuarios.form.nombre')" />
          <DxRequiredRule :message="$t('usuarios.form.validacion.nombre')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Apellidos" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('usuarios.form.apellidos')" />
          <DxRequiredRule :message="$t('usuarios.form.validacion.apellidos')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Email" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('usuarios.form.email')" />
          <DxRequiredRule :message="$t('usuarios.form.validacion.email')" />
          <DxEmailRule :message="$t('usuarios.form.validacion.email_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Roles" editor-type="dxTagBox" :col-span="3"
          :editor-options="{ ...getRolesProperties(), ...selectRolOptions }">
          <DxLabel :text="$t('usuarios.form.rol')" />
          <DxCustomRule :validation-callback="validateRoles" :message="$t('usuarios.form.validacion.rol')" />
        </DxSimpleItem>
      </DxGroupItem>

      <!-- Datos del agente -->
      <DxGroupItem :col-span="6" :col-count="6">
        <DxSimpleItem :visible="esAgente" :col-span="6">
          <span class="dx-field-item-label-text text-success">{{
            $t("usuarios.form.datos_agente")
            }}</span>
        </DxSimpleItem>
        <DxSimpleItem :visible="esAgente" data-field="Documento" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('usuarios.form.dni_nie')" />
          <DxRequiredRule :message="$t('usuarios.form.validacion.dni_nie')" />
          <DxPatternRule :pattern="dniNiePattern" :message="$t('usuarios.form.validacion.dni_nie_patron')" />
        </DxSimpleItem>
        <DxSimpleItem :visible="esAgente" data-field="Telefono" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('usuarios.form.telefono')" />
          <DxRequiredRule :message="$t('usuarios.form.validacion.telefono')" />
          <DxPatternRule :pattern="telefonoPattern" :message="$t('usuarios.form.validacion.telefono_patron')" />
        </DxSimpleItem>
        <DxSimpleItem :visible="esAgente" data-field="IdEmpresaAgentes" editor-type="dxSelectBox" :col-span="3"
          :editor-options="{ ...getSelectBoxDefaultProperties(), ...selectEmpresaAgentesOptions }">
          <DxLabel :text="$t('usuarios.form.empresa')" />
          <DxCustomRule :validation-callback="validateEmpresaAgentes" :message="$t('usuarios.form.validacion.tipo')" />
        </DxSimpleItem>
        <DxSimpleItem :visible="props.isEditMode && esAgente && tieneEstado" data-field="CodigoEstado" editor-type="dxTextBox"
          :col-span="3"
          :editor-options="{ readOnly: true, value: intl.i18n.t(`agentes.estado.${(model as DetailUsuarioModel)?.CodigoEstado}`) }">
          <DxLabel :text="$t('usuarios.form.estado')" />
        </DxSimpleItem>
        <DxEmptyItem :visible="props.isEditMode && esAgente && !tieneEstado" :col-span="3" />
        <DxSimpleItem :visible="showDelegacionesInmobiliarias" data-field="IdsDelegacionInmobiliaria" editor-type="dxTagBox" :col-span="3"
          :editor-options="{ ...getSelectBoxDefaultProperties(), ...tagBoxDelegacionInmobiliariaOptions }">
          <DxLabel :text="$t('usuarios.form.delegaciones_inmobiliarias')" />
          <DxCustomRule :validation-callback="validateDelegacionesInmobiliarias"
            :message="$t('usuarios.form.validacion.delegaciones_inmobiliarias')" />
        </DxSimpleItem>
        <DxEmptyItem :visible="showDelegacionesInmobiliarias" :col-span="3" />
        <DxSimpleItem :visible="esAgente" data-field="Validado" :col-span="6">
          <DxCheckBox v-model="props.model!.Validado" :text="$t('usuarios.form.validado')">
          </DxCheckBox>
          <DxLabel :visible="false" />
        </DxSimpleItem>
        <DxSimpleItem :visible="props.isEditMode" data-field="FechaUltimoAcceso" editor-type="dxTextBox" :col-span="3"
          :editor-options="{ readOnly: true, value: (model as DetailUsuarioModel)?.FechaUltimoAcceso }">
          <DxLabel :text="$t('usuarios.form.fecha_ultimo_acceso')" />
        </DxSimpleItem>
        <DxSimpleItem :visible="props.isEditMode && esAgente" data-field="ComparacionesDisponibles" editor-type="dxNumberBox" 
          :editor-options="{ min: 0, step: 1, showSpinButtons: true, disabled: !canEditComparacionesDisponibles }" :col-span="3">
          <DxLabel :text="$t('usuarios.form.comparaciones_disponibles')" />
          <DxRequiredRule :message="$t('usuarios.form.validacion.comparaciones_disponibles')" />
        </DxSimpleItem>
      </DxGroupItem>

      <DxGroupItem :col-span="6" :col-count="6">
        <DxSimpleItem :visible="esTrabajadorExterno" editor-type="dxCheckBox" data-field="DatosBOExterno.AsociadoTodasEmpresas" :col-span="3">
          <DxLabel :text="$t('usuarios.form.asociadoTodasEmpresas')" />
        </DxSimpleItem>
        <DxSimpleItem :visible="esTrabajadorExterno" editor-type="dxTagBox" data-field="DatosBOExterno.IdsEmpresaAgentes" :col-span="3" :editor-options="{ ...getSelectBoxDefaultProperties(), ...selectEmpresaAsociadasOptions }">
          <DxLabel :text="$t('usuarios.form.empresasAsociadas')" />
          <DxCustomRule :validation-callback="validateEmpresasAsociadas" :message="$t('usuarios.form.validacion.empresasAsociadas')" />
        </DxSimpleItem>
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script setup lang="ts">
import { messageBoxResult } from '@components/dialogs/message-box';
import type { CreateUserModel, DetailUsuarioModel, EditUserModel } from '@api/api';
import { useModalBuilder, type ToolbarReference } from '@helpers/modal-building-helper';
import { DxCheckBox, DxTagBox, type DxButton } from 'devextreme-vue';
import {
  DxEmailRule,
  DxForm,
  DxLabel,
  DxColCountByScreen,
  DxRequiredRule,
  DxPatternRule,
  DxEmptyItem,
  DxSimpleItem,
  DxGroupItem,
} from "devextreme-vue/form";
import { DxCustomRule } from 'devextreme-vue/validator';
import { computed, getCurrentInstance, onBeforeMount, onMounted, reactive, ref, watch } from 'vue';
import { useIntl } from '@services/i18n';
import { getSelectBoxDefaultProperties } from '@helpers/grid-helper';
import validationEngine from "devextreme/ui/validation_engine";
import { useApi } from '@api/integration';
import { toastError, toastSuccess } from '@/.shared/services/notification-service';
import { ApiError } from '@/.shared/services/http';
import { UNABLE_TO_CHANGE_USER_TYPE, USER_WITH_DUPLICATED_EMAIL } from '@/.shared/errors/codes';
import { PermissionsApp, useAuthorization } from '@/.shared/services/auth/authorization/authorization-service-impl';

const api = useApi();
const auth = useAuthorization();
const formInstance = ref<DxForm>();
const intl = useIntl();
const props = defineProps({
  model: {
    type: Object as () => DetailUsuarioModel | CreateUserModel,
    required: false
  },
  isEditMode: {
    type: Boolean,
    required: true
  }
});
const selectEmpresaAgentesOptions = reactive<any>({
  showClearButton: false
});
const selectEmpresaAsociadasOptions = reactive<any>({});

const selectRolOptions = reactive<any>({});

const dniNiePattern = ref<RegExp>(/(^\d{8}[A-Za-z]$)|(^[XYZ]\d{7}[A-Za-z]$)/);
const telefonoPattern = ref<RegExp>(/^\d{9}$/);
const tagBoxDelegacionInmobiliariaOptions = reactive<DxTagBox>({});

const esAgente = computed(() => {
  return props.model?.Roles.includes('AGENTE') || props.model?.Roles.includes('SUPERAGENTE') || 
    props.model?.Roles.includes('DIRECTOR_INMOBILIARIA') || props.model?.Roles.includes('COORDINADOR_DELEGACION_INMOBILIARIA')
    || props.model?.Roles.includes('AGENTE_INMOBILIARIA');
})

const esTrabajadorExterno = computed(() => {
  return props.model?.Roles.includes('BO_EXTERNO');
})

const canEditComparacionesDisponibles = computed(() => {
  return auth.hasPermission(PermissionsApp.EditComparacionesAgente);
})

const tieneEstado = computed(() => {
  return (props.model as DetailUsuarioModel)?.CodigoEstado != null;
})

onMounted(async () => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!)

  configureButtons(modal);
});

onBeforeMount(async () => {
  await setEmpresaAgentesDatasource();
  selectRolOptions.dataSource = await api.callStandardApi("getRolesSelector", { showLoading: false });
  selectEmpresaAsociadasOptions.dataSource = await api.callStandardApi("getEmpresaAgentesSelector", { showLoading: false });

  if (showDelegacionesInmobiliarias.value && props.model?.IdEmpresaAgentes) {
    tagBoxDelegacionInmobiliariaOptions.dataSource = await api.callStandardApi("getDelegacionInmobiliariaSelectorByInmobiliaria", { showLoading: false }, props.model?.IdEmpresaAgentes);
  }
});

watch(() => props.model?.Roles, async(newValue) => {
  setEmpresaAgentesDatasource();
});

watch(() => props.model?.DatosBOExterno?.AsociadoTodasEmpresas, async(newValue) => {
  if (newValue) {
    if(props.model?.DatosBOExterno) {
      props.model.DatosBOExterno.IdsEmpresaAgentes = [];
    }
    selectEmpresaAsociadasOptions.disabled = true;
  } else {
    selectEmpresaAsociadasOptions.disabled = false;
  }
}, { immediate: true });

const setEmpresaAgentesDatasource = async() => {
  if (props.model?.Roles?.includes("SUPERAGENTE") || props.model?.Roles?.includes("AGENTE")){
    selectEmpresaAgentesOptions.dataSource = await api.callStandardApi("getEmpresaAgentesSelector", { showLoading: false }, ["COLABORADORA"]);
  }
  else if (props.model?.Roles?.includes('DIRECTOR_INMOBILIARIA') || props.model?.Roles?.includes('COORDINADOR_DELEGACION_INMOBILIARIA')
    || props.model?.Roles?.includes('AGENTE_INMOBILIARIA')){
    selectEmpresaAgentesOptions.dataSource = await api.callStandardApi("getEmpresaAgentesSelector", { showLoading: false }, ["INMOBILIARIA"]);
  }
  else {
    selectEmpresaAgentesOptions.dataSource = await api.callStandardApi("getEmpresaAgentesSelector", { showLoading: false });
  }
}

function getRolesProperties(): DxTagBox {
  return {
    valueExpr: 'NormalizedName',
    displayExpr: 'Name',
    searchEnabled: true
  }
}

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;
  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());
  okButton.update(w => w.text = `${intl.i18n.t("shared.ui.buttons.save")}`);
  okButton.update(w => w.onClick = async () => {
    saveOrEdit().then((value) => {
      if (value)
        modal.close(messageBoxResult.ok)
    });
  }
  );
  cancelButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
}

const saveOrEdit = async () => {
  var res = validationEngine.validateGroup("validacionUsuario");

  if (res.isValid) {
    if (props.isEditMode) {
      try {
        await api.callStandardApi("editUsuario", { showLoading: true }, props.model as EditUserModel)
          .then(() => toastSuccess(intl.i18n.t('usuario.edicion_exito')));
      }
      catch (e: any) {
        if (e instanceof ApiError && e.details?.errorList.length === 1 && [USER_WITH_DUPLICATED_EMAIL, UNABLE_TO_CHANGE_USER_TYPE].includes(e.details.errorList[0].Code)) {
          toastError(intl.i18n.t(`shared.errors.api.${e.details.errorList[0].Code}`))
        }
        else throw e;
        return false;
      }
    } else {
      try {
        await api.callStandardApi("createUsuario", { showLoading: true }, props.model as CreateUserModel)
          .then(() => toastSuccess(intl.i18n.t('usuario.creacion_exito')));
      }
      catch (e: any) {
        if (e instanceof ApiError && e.details?.errorList.length === 1 && [USER_WITH_DUPLICATED_EMAIL].includes(e.details.errorList[0].Code)) {
          toastError(intl.i18n.t(`shared.errors.api.${e.details.errorList[0].Code}`))
        }
        else throw e;
        return false;
      }
    }
    return true;
  } else {
    toastError(intl.i18n.t('usuario.revise_validacion'));
  }

  return false;
}

function validateRoles(e: any) {
  if (!Array.isArray(e.value) || e.value.length === 0 || e.value.length > 1) {
    return false;
  }
  return true;
}

function validateEmpresaAgentes(e: any) {
  return selectEmpresaAgentesOptions.dataSource.some((option: { Id: any; }) => option.Id === e.value);
}

function validateEmpresasAsociadas(e: any) {
  if (!props.model?.Roles.includes('BO_EXTERNO')) {
    return true;
  }

  if (props.model?.DatosBOExterno?.AsociadoTodasEmpresas) {
    return true;
  }
  
  return Array.isArray(e.value) && e.value.length > 0;
}

const showDelegacionesInmobiliarias = computed(() => {
  return props.model?.Roles.includes('COORDINADOR_DELEGACION_INMOBILIARIA')
    || props.model?.Roles.includes('AGENTE_INMOBILIARIA');
})

watch(() => props.model?.IdEmpresaAgentes, async(newValue) => {
  if (showDelegacionesInmobiliarias.value && newValue) {
    props.model!.IdsDelegacionInmobiliaria = [];
    tagBoxDelegacionInmobiliariaOptions.dataSource = await api.callStandardApi("getDelegacionInmobiliariaSelectorByInmobiliaria", { showLoading: false }, newValue);
  }
})

const validateDelegacionesInmobiliarias = (e: any) => {
  if (props.model!.Roles.includes('COORDINADOR_DELEGACION_INMOBILIARIA')) {
    return e.value.length > 0;
  }
  else if (props.model!.Roles.includes('AGENTE_INMOBILIARIA')) {
    return e.value.length === 1;
  }
  else if (props.model!.Roles.includes('DIRECTOR_INMOBILIARIA')) {
    return e.value.length === 0;
  }
  return false;
}

</script>